import { IResponse } from "../../../_services/interface/user.interface";

export const checkCollaboratorPermission = (validation: IResponse, guid_client: string, permission: string) => {
  const _c = validation.clients.find((x) => x.guid_client === guid_client);
  if (_c) {
    if (_c.permissions.includes("org.owner")) {
      return true;
    }

    if (_c.permissions.includes("org.admin")) {
      return true;
    }

    return _c.permissions.includes(permission);
  } else {
    return false;
  }
};

/**
 * GEN-3775 — mesma regra do backend para salvar os grupos de e-mail da Base Cadastral: dono/admin, ou
 * `registry.read` + `registry.export` enxergando TODAS as empresas (escopo ausente conta como todas,
 * como lá). Quem vê só parte das empresas não decide para onde vão os avisos de todas, e mandar dado
 * para caixa externa é exportar.
 */
export const checkRegistryFullAccess = (validation: IResponse, guid_client: string) => {
  const _c = validation.clients.find((x) => x.guid_client === guid_client);
  if (!_c) return false;
  if (_c.permissions.includes("org.owner") || _c.permissions.includes("org.admin")) return true;
  const escopo = _c.companiesAccess;
  return (
    _c.permissions.includes("registry.read") &&
    _c.permissions.includes("registry.export") &&
    (escopo == null || escopo === "all")
  );
};

export const checkIsOwner = (validation: IResponse, guid_client: string) => {
  const _c = validation.clients.find((x) => x.guid_client === guid_client);

  return !!_c && _c.permissions.includes("org.owner");
};
